import React,{useEffect,useState,useMemo} from 'react';
import { useSelector } from 'react-redux';
import {useGetAllPersonMeetingByParentId} from '../../Hooks/index';
import {Grid,Box,CircularProgress,Typography,Tooltip} from '@mui/material';
import DyDataGrid from '../../../../components/GlobalComponents/DyDataGrid/DyDataGrid';
const PersonStatus:React.FC=()=> {
  const priodId:any=useSelector((state:any)=>state.meetings.priodId);
  const meetingId:any=useSelector((state:any)=>state.meetings.meetingId);
  const teamId:any=useSelector((state:any)=>state.meetings.teamInfo.id);
  const{data:teamStatusData,isLoading}=useGetAllPersonMeetingByParentId(teamId,meetingId,priodId);

    const teamsColumns: any = useMemo(()=>
    [
      {
        field: "rowid",
        headerName: "ردیف",
        width: 35,
        //sortable: false,
        align:'center',
        headerAlign:'center',
        //renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
        renderCell: (params: any) =>
            params.api.getAllRowIds().indexOf(params.id) + 1,
      }
      ,
      { field: 'name',
      headerName: 'نام',
      align:'center',
      sortable:false,
      headerAlign:'center',
       width: 150 
      }
       ,
       { field: 'objectiveCount',
      headerName: 'تعداد اهداف',
      align:'center',
      sortable:false,
      headerAlign:'center',
       width: 150 
      }
       ,
       { field: 'keyResultCount',
        headerName: 'تعداد نتیجه',
        align:'center',
        sortable:false,
        headerAlign:'center',
         width: 150 
        }
         ,
       { field: 'evaluationPercentage',
      headerName: 'درصد ارزیابی نتیجه',
      align:'center',
      sortable:false,
      headerAlign:'center',
       width: 150 
      }   ,
      { field: 'evaluationPercentageB',
       headerName: 'درصد ارزیابی BAU',
     align:'center',
     sortable:false,
     headerAlign:'center',
      width: 150 
     }
      ,
      { field: 'score',
     headerName: 'امتیاز نتیجه',
     align:'center',
     sortable:false,
     headerAlign:'center',
      width: 150,
      renderCell: (par: any) => {
        // console.log(par?.row?.score)
        let score: string = par?.row?.score;
        // console.log(score);
        if (typeof score === "string" && score.includes("%")) {
          let pureNum = score.slice(0, score.length - 1);
          let intVal = +pureNum;
          let color = "";
          let fColor = "";
          switch (true) {
            case intVal >= 70:
              color = "#D5F7D4";
              fColor = "#125610";
              break;
            case intVal < 70 && intVal > 30:
              color = "#FFF8D0";
              fColor = "#6B6440";
              break;
            default:
              color = "#FFEEE5";
              fColor = "#993600";
              break;
          }
          return (
            <Box
              m={3}
              borderRadius={2}
              width={"100%"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"65%"}
              bgcolor={color}
              my={1}
            >
              <Typography
                px={8}
                color={fColor}
                fontSize={"0.8rem"}
                fontWeight={400}
              >
                {intVal}
              </Typography>
            </Box>
          );
        } else {
        //   return (
        //     <Box>
        //       <Typography>{score}</Typography>
        //     </Box>
        //   );
        // let pureNum = score.slice(0, score.length - 1);
        let intVal = +score;
        let color = "";
        let fColor = "";
        switch (true) {
          case intVal >= 70:
            color = "#D5F7D4";
            fColor = "#125610";
            break;
          case intVal < 70 && intVal > 30:
            color = "#FFF8D0";
            fColor = "#6B6440";
            break;
          default:
            color = "#FFEEE5";
            fColor = "#993600";
            break;
        }
        return (
          <Box
            m={3}
            borderRadius={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"65%"}
            bgcolor={color}
            my={1}
          >
            <Typography
              px={8}
              color={fColor}
              fontSize={"0.8rem"}
              fontWeight={400}
            >
              {intVal}
            </Typography>
          </Box>
         )
        }
      },
     }
      ],[]);

    // if (isLoading) {
    //   return <Box height={'300px'} display={'flex'} alignItems={'center'} justifyContent={'center'}  >
    //      <CircularProgress color='info'  />
    //   </Box> 
    // }
  
  return (
   <Grid container    >
   <Grid item xs={12} >
   <Box width={'100%'} height={'100%'} >
   <DyDataGrid 
   data={teamStatusData || []}
   columns={teamsColumns}
   hideFooter={false}
   selectionModel={''}
   initialOnRowClick={()=>{}}
   setSelectionModel={()=>{}}

   />
   </Box>
   </Grid>
   </Grid>
  )
}

export default PersonStatus